import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Breadcrumb } from '@edx/paragon';
import { getBreadcrumbsByPath } from '@build-utils/helpers/breadcrumbsHelper';
import getStructuredData from '@prospectus/common/ui/PageTitleBreadcrumbs/structuredData';

interface CourseBreadcrumbsProps {
  courseName: string;
  prospectusPath: string;
}

function CourseBreadcrumbs({
  courseName,
  prospectusPath,
}: CourseBreadcrumbsProps) {
  const links = [
    {
      label: 'Home',
      href: '/',
    },
    // Remove if the first character is a forward slash.
    // Omit the last entry which will eventually be courseName to avoid duplicated labels.
    ...getBreadcrumbsByPath(prospectusPath.charAt(0) === '/' ? prospectusPath.slice(1) : prospectusPath, courseName).slice(0, -1),
  ];
  const seoBreadcrumbs = [...links.filter((({ label }) => label !== courseName)), { label: courseName }];

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(getStructuredData(seoBreadcrumbs))}
        </script>
      </Helmet>
      <div className="pt-3 small d-none d-sm-block">
        <Breadcrumb links={links} activeLabel={courseName} />
      </div>
      <div className="pt-3 small d-flex d-sm-none mobile-crumb">
        <Breadcrumb links={links} isMobile activeLabel={courseName} />
      </div>
    </>
  );
}

export default CourseBreadcrumbs;
